import { Grid, Button, Tooltip } from "@mui/material";
// import { useLocation } from "react-router-dom";

// import AddonsArea from "./AddonsArea/index";
// import MessagesArea from "./MessagesArea/index";
// import SettingsArea from "./SettingsArea/index";
import UserDetailsArea from "./UserDetailsArea/index";
import HelpIcon from "../Icons/Help";
// import navItems from "../../sidebar/dashboardItems";
import { styled } from "@mui/system";
import { HELP_HOME } from "../../../constants/generalConstants";
// import { userRoleAtom } from "../../../atom/atoms";
// import { useAtom } from "jotai";

// const StyledGrid = styled(Grid)`
//   height: 100%;
//   background-color: ${(props) => props.theme.palette.background.menuBackground};
//   max-width: 15rem;
//   min-width: 15rem;
//   border-radius: 45px;
//   padding-bottom: 2.5rem;
//   box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
// `;

// const StyledNavLink = styled(NavLink)`
//   display: flex;
//   justify-content: center;
//   text-decoration: none;
//   color: ${(props) => props.theme.palette.secondary.contrastText};
//   font-weight: ${(props) => (props.active ? `bold` : `normal`)};
// `;

// const StyledDivider = styled(Divider)`
//   align-self: center;
//   justify-self: center;
//   &.MuiDivider-root {
//     border-color: ${(props) => props.theme.palette.background.default};
//     margin: 1rem;
//   }
// `;
const StyledGridItem = styled(Grid)`
  background: ${(props) => props.theme.palette.background.default};
  // margin-top: 2.6rem;
  // margin-left: 1.5rem;
  // height: 4.5rem;
  max-width: 15rem;
  min-width: 15rem;
  border-radius: 2.75rem 2.75px 2.75px 2.75rem;
  align-items: center;
  // &.MuiGrid-item {
  //   padding-top: 0px;
  //   padding-left: 0px;
  // }
`;

const PersonalMenu = ({ sx, ...props }) => {
  // let resolved = useLocation();
  // const routes = navItems[0].pages;
  // const routeChildren = routes.find((item) => item.href === resolved.pathname);
  // const [userRole] = useAtom(userRoleAtom);
  // const hasUserRole = userRole === "user";

  const openHelp = () => {
    const helpMap = JSON.parse(window.sessionStorage.getItem("helpMap"));
    window.open(
      helpMap?.[window.location.pathname]
        ? helpMap?.[window.location.pathname]
        : helpMap?.[HELP_HOME],
      "_blank"
    );
  };

  return (
    // <StyledGrid container sx={sx} flexDirection={"column"} xs={12}>
    <Grid
      container
      xs={12}
      justifyContent="space-between"
      alignItems="center"
      sx={{ paddingRight: 2, marginBottom: 0, borderRadius: 40 }}
    >
      <StyledGridItem
        item
        direction="row"
        marginLeft="40px"
        xs={6}
        sx={{
          display: { xs: "none", md: "flex" },
          borderRadius: 40,
        }}
      >
        <Tooltip placement="bottom" title="Help">
          <Button onClick={() => openHelp()}>
            <HelpIcon />
          </Button>
        </Tooltip>
      </StyledGridItem>
      <StyledGridItem
        item
        direction="row"
        xs={6}
        sx={{
          display: { xs: "none", md: "flex" },
          borderRadius: 40,
        }}
      >
        <UserDetailsArea
          userFullName={props.userDetails.fullName}
          publisherName={props.userDetails.publisherName}
          roleType={props.userDetails.roleType}
        />
      </StyledGridItem>
    </Grid>

    /*   {<Grid
        container
        item
        direction={"row"}
        justifyContent={"space-around"}
        alignItems={"center"}
      >
        <SettingsArea />
      </Grid> }*/
    /*{ {routeChildren?.children !== undefined ? (
        <Grid item>
          <List sx={{ padding: 0, marginBottom: 0 }}>
            {routeChildren?.children.map((route) => (
              <ListItem key={route.href} sx={{ marginTop: -3 }}>
                {(route.href !== "/upgradePlan" ||
                  (route.href === "/upgradePlan" && !hasUserRole)) && (
                  <StyledNavLink
                    active={route.href === resolved.pathname}
                    to={route.href}
                  >
                    {route.title}
                  </StyledNavLink>
                )}
              </ListItem>
            ))}
            <Grid item>
              <StyledDivider />
            </Grid>
          </List>
        </Grid>
      ) : null} }*/

    /*{ <Grid
        item
        sx={{
          marginTop: -2,
        }}
      >
        <AddonsArea data={props.addons} />
      </Grid>
      <Grid item>
        <StyledDivider />
      </Grid>
      <Grid item>
        <MessagesArea data={props.messages} />
      </Grid> }*/
    // </StyledGrid>
  );
};

export default PersonalMenu;
